module.exports = __webpack_public_path__ + "assets/003da36e93f5d472ef64a883c0fb602c.mp3";